import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import FifthFlow from 'components/Flows/FifthFlows/FifthFlows';
import FifthAnalysisDrawer from 'components/Analyses/FifthAnalyses/Drawer/Drawer';

const FifthFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <FifthAnalysisDrawer />
      <FifthFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <FifthFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);